import React from "react";
import Image from "next/image";
import styles from "./CrmVendorSection.module.css";

export default function CrmVendorSection({
  eyebrow,
  title,
  body,
  bullets = [],
  imageSrc,
  imageAlt,
  ctaHref = "/contact",
  ctaText = "Learn More",
  reverse = false,
  logoClassName,
}) {
  return (
    <section className={`${styles.section} py-4 py-lg-5`}>
      <div className="container">
        <div className="row g-4 align-items-center">
          {/* Image column */}
          <div className={`col-12 col-lg-6 ${reverse ? "order-lg-2" : ""}`} data-reveal="slide-up">
            <div className={styles.figure}>
              <div className={styles.imageWrap}>
                <Image
                  src={imageSrc}
                  alt={imageAlt || "Service highlight"}
                  style={{ width: "100%", height: "auto", display: "block", borderRadius: "12px" }}
                  width={600}
                  height={400}
                />
              </div>
              {logoClassName && (
                <i className={`${styles.logoMark} ${logoClassName}`} aria-hidden></i>
              )}
            </div>
          </div>

          {/* Content column */}
          <div className={`col-12 col-lg-6 ${reverse ? "order-lg-1" : ""}`} data-reveal="slide-up">
            <div className={styles.eyebrow}>{eyebrow}</div>
            <h3 className={styles.title}>{title}</h3>
            {body && <p className={styles.body}>{body}</p>}
            {bullets?.length > 0 && (
              <ul className={styles.list}>
                {bullets.map((b) => (
                  <li key={b} className={styles.item}>
                    <i className="fa-regular fa-circle-check"></i>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            )}
            <a href={ctaHref} className={styles.cta}>{ctaText}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
